'use client';

import _slicedToArray from "/codebuild/output/src4231/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/codebuild/output/src4231/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
  if (placement === "center" || arrowPosition === "center") {
    return {
      top: arrowY
    };
  }
  if (placement === "end") {
    return {
      bottom: arrowOffset
    };
  }
  if (placement === "start") {
    return {
      top: arrowOffset
    };
  }
  return {};
}
function verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
  if (placement === "center" || arrowPosition === "center") {
    return {
      left: arrowX
    };
  }
  if (placement === "end") {
    return _defineProperty({}, dir === "ltr" ? "right" : "left", arrowOffset);
  }
  if (placement === "start") {
    return _defineProperty({}, dir === "ltr" ? "left" : "right", arrowOffset);
  }
  return {};
}
var radiusByFloatingSide = {
  bottom: "borderTopLeftRadius",
  left: "borderTopRightRadius",
  right: "borderBottomLeftRadius",
  top: "borderBottomRightRadius"
};
function getArrowPositionStyles(_ref3) {
  var position = _ref3.position,
    arrowSize = _ref3.arrowSize,
    arrowOffset = _ref3.arrowOffset,
    arrowRadius = _ref3.arrowRadius,
    arrowPosition = _ref3.arrowPosition,
    arrowX = _ref3.arrowX,
    arrowY = _ref3.arrowY,
    dir = _ref3.dir;
  var _position$split = position.split("-"),
    _position$split2 = _slicedToArray(_position$split, 2),
    side = _position$split2[0],
    _position$split2$ = _position$split2[1],
    placement = _position$split2$ === void 0 ? "center" : _position$split2$;
  var baseStyles = _defineProperty({
    width: arrowSize,
    height: arrowSize,
    transform: "rotate(45deg)",
    position: "absolute"
  }, radiusByFloatingSide[side], arrowRadius);
  var arrowPlacement = -arrowSize / 2;
  if (side === "left") {
    return _objectSpread(_objectSpread(_objectSpread({}, baseStyles), horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {}, {
      right: arrowPlacement,
      borderLeftColor: "transparent",
      borderBottomColor: "transparent"
    });
  }
  if (side === "right") {
    return _objectSpread(_objectSpread(_objectSpread({}, baseStyles), horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {}, {
      left: arrowPlacement,
      borderRightColor: "transparent",
      borderTopColor: "transparent"
    });
  }
  if (side === "top") {
    return _objectSpread(_objectSpread(_objectSpread({}, baseStyles), verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {}, {
      bottom: arrowPlacement,
      borderTopColor: "transparent",
      borderLeftColor: "transparent"
    });
  }
  if (side === "bottom") {
    return _objectSpread(_objectSpread(_objectSpread({}, baseStyles), verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {}, {
      top: arrowPlacement,
      borderBottomColor: "transparent",
      borderRightColor: "transparent"
    });
  }
  return {};
}
export { getArrowPositionStyles };